module.exports = __webpack_public_path__ + "img/Jalouzien.1686cbaf.png";